import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { GLOSSARY } from "@/lib/glossary";
import { Question, Sparkle } from "@phosphor-icons/react";

export const askRowan = (text, title) => {
  window.dispatchEvent(new CustomEvent("bk-ask-ai", { detail: { text, title } }));
};

// Wraps an accounting term with a quiet "?" that opens Rowan's three-part explanation.
export function RowanTerm({ term, children, size = 14, className = "" }) {
  const entry = GLOSSARY[term];
  if (!entry) return children || null;
  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      {children}
      <Popover>
        <PopoverTrigger asChild>
          <button type="button" aria-label={`What does ${entry.title} mean?`} data-testid={`term-${term}`} className="rounded-full inline-flex items-center justify-center transition-colors hover:bg-[#F6EEDF]" style={{ color: "var(--bk-gold)", width: size + 8, height: size + 8 }}>
            <Question size={size} weight="fill" />
          </button>
        </PopoverTrigger>
        <PopoverContent align="start" className="w-[22rem] rounded-2xl p-4 border" style={{ background: "var(--bk-rowan-bg)", borderColor: "var(--bk-rowan-border)" }} data-testid={`term-popover-${term}`}>
          <p className="text-xs uppercase tracking-[0.18em] font-semibold mb-1.5 flex items-center gap-1.5" style={{ color: "var(--bk-gold)" }}><Sparkle size={12} weight="fill" /> Rowan explains</p>
          <p className="font-semibold text-sm" style={{ color: "var(--bk-text)" }}>{entry.title}</p>
          <dl className="mt-2 space-y-1.5 text-sm leading-relaxed" style={{ color: "var(--bk-text)" }}>
            <div><dt className="text-[11px] uppercase tracking-wider font-semibold" style={{ color: "var(--bk-text-2)" }}>What it means</dt><dd>{entry.what}</dd></div>
            <div><dt className="text-[11px] uppercase tracking-wider font-semibold" style={{ color: "var(--bk-text-2)" }}>Why it matters</dt><dd>{entry.why}</dd></div>
            <div><dt className="text-[11px] uppercase tracking-wider font-semibold" style={{ color: "var(--bk-text-2)" }}>What to do</dt><dd>{entry.do}</dd></div>
          </dl>
          <button type="button" onClick={() => askRowan(`Explain "${entry.title}" using my actual numbers. What should I do about it right now?`, entry.title)} data-testid={`term-ask-rowan-${term}`} className="mt-3 text-xs font-semibold underline underline-offset-2" style={{ color: "var(--bk-accent)" }}>Ask Rowan with my numbers</button>
        </PopoverContent>
      </Popover>
    </span>
  );
}

// Compact row of the terms relevant to the current screen.
export function ScreenTerms({ terms = [] }) {
  const list = terms.filter((t) => GLOSSARY[t]);
  if (!list.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="screen-terms">
      <span className="text-[11px] uppercase tracking-wider font-semibold" style={{ color: "var(--bk-text-2)" }}>Terms here:</span>
      {list.map((t) => (
        <RowanTerm key={t} term={t} size={12} className="text-xs font-medium px-2 py-0.5 rounded-full" >
          <span style={{ color: "var(--bk-text-2)" }}>{GLOSSARY[t].title}</span>
        </RowanTerm>
      ))}
    </div>
  );
}
